
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/gallery-add","xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#8d98aa"}},[_c('path',{attrs:{"d":"M15.004 8.743a4.6 4.6 0 11-4.6 4.6 4.6 4.6 0 014.6-4.6zm0 6.686a2.089 2.089 0 10-2.089-2.09 2.092 2.092 0 002.089 2.09z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M24.998 37.91h-10c-4.616 0-7.742-.977-9.839-3.073s-3.07-5.223-3.07-9.839v-10c0-4.616.977-7.742 3.073-9.839s5.224-3.07 9.839-3.07h6.664a1.25 1.25 0 110 2.5h-6.664c-3.909 0-6.474.744-8.072 2.341s-2.341 4.162-2.341 8.071v10c0 3.909.744 6.474 2.341 8.072s4.162 2.341 8.072 2.341h10c3.909 0 6.474-.744 8.072-2.341s2.341-4.162 2.341-8.072v-8.334a1.25 1.25 0 012.5 0v8.331c0 4.616-.977 7.742-3.073 9.839s-5.227 3.073-9.843 3.073z"}}),_c('g',{attrs:{"data-name":"Group 591","opacity":".4"}},[_c('path',{attrs:{"data-name":"Vector","d":"M35.407 9.61h-9.2a1.254 1.254 0 010-2.507h9.2a1.254 1.254 0 010 2.507z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M30.803 14.207a1.254 1.254 0 01-1.25-1.25v-9.2a1.254 1.254 0 012.507 0v9.2a1.254 1.254 0 01-1.257 1.25z"}})]),_c('path',{attrs:{"data-name":"Vector","d":"M4.459 32.844a1.247 1.247 0 01-1.038-.555 1.256 1.256 0 01.338-1.739l8.216-5.532a5.016 5.016 0 015.909.324l.011.009.544.479a2.46 2.46 0 003.065 0l6.93-5.971a4.937 4.937 0 016.326 0l2.715 2.34a1.252 1.252 0 01-1.628 1.9l-2.715-2.334a2.459 2.459 0 00-3.07 0l-6.931 5.963a4.937 4.937 0 01-6.326 0l-.011-.009-.544-.479a2.485 2.485 0 00-2.883-.14l-8.208 5.532a1.241 1.241 0 01-.7.212z","opacity":".4"}})])])
          )
        }
      }
    